// Core packages
import { Injectable } from '@angular/core';

// Third party packages
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

// Custom packages
import { ListApiResponseV2 } from 'src/app/shared/interfaces/_base/api-response.interface';
import { ApiService } from 'src/app/shared/services/api.service';
import { HelperService } from 'src/app/shared/services/helper.service';

@Injectable({
  providedIn: 'root'
})
export class DdtsService {

  /**
   * Class constructor
   */
  constructor(
    private apiService: ApiService,
    private helperService: HelperService
  ) { }

  /**
   * Get Ddts list for given query params
   *
   * @since 1.0.0
   *
   * @param [start] Query left offset
   * @param [limit] Results number
   * @param [sort] Sorting field name
   * @param [sortVersus] Sorting versus. Can be 'asc' or 'desc'
   * @param [search] Filtering object with fildering data string
   */
  getList(start?: number, limit?: number, sort?: string, sortVersus?: string, search?: any): Observable<ListApiResponseV2> {
    const params: any = { start, limit, sort, sortVersus };
    if (search) {
      Object.keys(search).forEach(key => {
        const newParamKey = `search[${key}]`;
        const newParamValue = search[key];
        params[newParamKey] = newParamValue;
      });
    }
    return this.apiService.apiCall('GET', 'ddts', params);
  }

  /**
   * Get an exportation file of all compananies
   *
   * @since 1.0.0
   */
  getExport(): Observable<any> {
    return this.apiService.apiCall('GET', 'ddts/export', {}, { responseType: 'blob' })
      .pipe(
        catchError(err => {
          return this.helperService.parseErrorBlob(err);
        })
      );
  }

  /**
   * Get given ddtId data from back-end
   *
   * @since 1.0.0
   *
   * @param ddtId ID of the ddt to get
   */
  get(ddtId: string): Observable<any> {
    return this.apiService.apiCall('GET', `ddts/${ddtId}`).pipe(
      catchError(err => {
        this.helperService.handleError(err);
        return throwError(err);
      })
    );
  }

  /**
   * Update ddt with given ddtId with given ddt data
   *
   * @since 1.0.0
   *
   * @param ddtId ID of ddt to update
   * @param data New ddt's data
   */
  update(ddtId: string, data: object): Observable<any> {
    return this.apiService.apiCall('PUT', `ddts/${ddtId}`, data);
  }

   /**
   * Get given checklist list
   *
   * @since 1.0.0
   *
   */
  getChecklist(): Observable<any> {
    return this.apiService.apiCall('GET', `ddts/checklist`).pipe(
      catchError(err => {
        this.helperService.handleError(err);
        return throwError(err);
      })
    );
  }
  
  /**
   * Get given checklist detail
   *
   * @since 1.0.0
   *
   */
  getChecklistDetail(ddtId: string): Observable<any> {
    return this.apiService.apiCall('GET', `ddts/checklist/${ddtId}`).pipe(
      catchError(err => {
        this.helperService.handleError(err);
        return throwError(err);
      })
    );
  }

  
   /**
   * Get ddtDocuments by code
   *
   * @since 1.0.0
   *
   */
    getDdtdocumentByCode(code: string): Observable<any> {
      return this.apiService.apiCall('GET', `ddts/ddt-documents/${code}`).pipe(
        catchError(err => {
          this.helperService.handleError(err);
          return throwError(err);
        })
      );
    }

}
